import Vue from 'vue';
import VueRouter from 'vue-router';
import VueCookies from "vue-cookies";
import goTo from 'vuetify/lib/services/goto'
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/analytics';

Vue.use(VueRouter);
Vue.use(VueCookies)

const siteIsDown = !!Number(process.env.VUE_APP_SITE_IS_DOWN);

const routes = [
    {
        path: '/',
        component: () => import(/* webpackChunkName: "public" */ "../views/pages/Main"),
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "public" */ "../views/pages/Home")
            },
            {
                path: '/o-projektu',
                component: () => import(/* webpackChunkName: "public" */ "../views/pages/About")
            },
            {
                path: '/politika-privatnosti',
                component: () => import(/* webpackChunkName: "public" */ "../views/pages/PrivacyPolicy")
            },
            {
                path: '/uslovi-korišćenja',
                component: () => import(/* webpackChunkName: "public" */ "../views/pages/TermsAndConditions")
            },
            {
                path: '/pravno-lice/:slug/:id',
                component: () => import(/* webpackChunkName: "public" */ "../views/pages/CompanyProfile")
            },
            {
                path: '/kontakt',
                component: () => import(/* webpackChunkName: "public" */ "../views/pages/Contact")
            }
        ],
        meta: {
            requiresAuth: siteIsDown,
            public: true
        }
    },
    {
        path: '/dashboard',
        component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard/AdminHome.vue'),
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard/Dashboard.vue'),
                meta: {
                    requiresAdmin: false
                }
            },
            {
                path: 'companies',
                component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard/Companies.vue'),
                meta: {
                    requiresAdmin: false
                }
            },
            {
                path: 'comments',
                component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard/Comments.vue'),
                meta: {
                    requiresAdmin: false
                }
            },
            {
                path: 'user-management',
                component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard/UserManagement.vue'),
                meta: {
                    requiresAdmin: true
                }
            },
            {
                path: 'settings',
                component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard/Settings.vue'),
                meta: {
                    requiresAdmin: true
                }
            },
        ],
        meta: {
            requiresAuth: true,
            public: false
        }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "Login" */ '../views/Login'),
        meta: {
            requiresAuth: false,
            public: true
        }
    },
    {
        path: '/radovi-na-sajtu',
        name: 'maintenance',
        component: () => import(/* webpackChunkName: "Maintenance" */ '../views/Maintenance'),
        meta: {
            requiresAuth: !siteIsDown,
            public: siteIsDown
        }
    },
    {
        path: '*',
        name: '404',
        component: () => import(/* webpackChunkName: "NotFound" */ "../views/NotFound"),
        meta: {
            requiresAuth: false,
            public: true
        }
    }
];

const router = new VueRouter({
    mode: 'history',
    scrollBehavior: (to, from, savedPosition) => {
        let scrollTo = 0;
        if (to.hash) {
            scrollTo = to.hash;
        } else if (savedPosition) {
            scrollTo = savedPosition.y;
        }
        return goTo(scrollTo);
    },
    routes
});

router.beforeEach((to, from, next) => {
    const isPublic = to.matched.some(record => record.meta.public);
    const currentUser = firebase.auth().currentUser;
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

    if (isPublic && requiresAuth) {
        if (currentUser) {
            next();
        } else {
            next({ path: '/radovi-na-sajtu' });
        }
    } else if (!isPublic && requiresAuth) {
        if (currentUser) {
            const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);
            if (requiresAdmin) {
                currentUser.getIdTokenResult().then(user => {
                    if (user.claims.admin === true) {
                        next();
                    } else {
                        next({ path: '/dashboard' });
                    }
                });
            } else {
                next();
            }
        } else {
            next({ path: '/login' });
        }
    } else if (to.path === '/login') {
        if (currentUser) {
            next({ path: '/dashboard' });
        } else {
            next();
        }
    } else {
        next();
    }
});

router.afterEach(to => {
    if (to.name !== 'maintenance' && !Vue.$cookies.get('consent').ga_disabled) {
        firebase.analytics().logEvent('page_view', { page_location: to.fullPath });
    }
});

export default router;
